import React from "react";
import ReactDOM from "react-dom/client";
import "./services/webCauseListCache";
import "./App.css";
import App from "./App";
import { registerServiceWorker } from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerServiceWorker();
